import { CreateJob, CreateLocation, CreateNewsBlogs, CreateUser, DeleteJob, DeleteLocation, DeleteNewsBlogs, DeleteUser, GetCVList, GetJobData, GetJobList, GetLocationData, GetLocationList, GetNewsBlogList, GetNewsBlogsData, GetSubscriberList, GetUserData, GetUserList, SendOtp, UpdateJob, UpdateLocation, UpdateNewsBlogs, UpdateUser, UserLogin, UserLogout, UserLogs, SubmittedForms, VerifyAndUpdatePassword, GetDashboardData, VerifyAuth, GetContactUsList, GetFormList, DeleteForm, CreateForm, GetFormData, UpdateForm, GetPolicyList, UpdatePolicy, GetAllForms, CreatePolicy, DeletePolicy, UpdatePolicyWebVisibility, ApproveForm, SafeguardingForm, TimesheetDetails, GetSubmittedFormDetailedData, CreateScoreForm, UpdateScoreForm, GetScoreFormData, DeleteScoreForm, UploadFormDocument, UploadTempImage, SaveCPDImages, GetCPDImages, DeleteCPDImage, UpdateCPDImage, UpdateImageOrder, UploadHandbook, GetHandbook, DeleteHandbook, GetEOMNominations, GetEOMStatus, UpdateEOMStatus, DeleteEOMNomination, GetEOMAvailableMonths, SaveEOMWinner, GetEOMWinner, GetEOMWinners, DeleteEOMWinner, GetEOMWinnerAvailableMonths, GetHouseList, GetHouseData, CreateHouse, UpdateHouse, DeleteHouse, GetVisitorReports, DownloadMergedForms } from '../ApiEndPoints';
import { axiosAuthParms, axiosGetAuthorize, axiosGetAuthorizeByWebToken, axiosGetMultiParams, axiosGetMultiParamsForWebToken, axiosPost, axiosPostAuthorize, axiosPostAuthorizeByWebToken, axiosPostAuthorizeBlob } from '../AxiosRequests';

export default class AdminServices {

    // Auth
    async userLogin(request) {
        return axiosPost(UserLogin, request);
    }

    async sendOtp(request) {
        return axiosPost(SendOtp, request);
    }

    async verifyAndUpdatePassword(request) {
        return axiosPost(VerifyAndUpdatePassword, request);
    }

    async userLogout(request) {
        return axiosPostAuthorize(UserLogout, request);
    }

    // User
    async getUserList(request) {
        return axiosGetMultiParams(GetUserList, request);
    }

    async getUserData(request) {
        return axiosGetAuthorize(GetUserData, request);
    }

    async createUser(request) {
        return axiosPostAuthorize(CreateUser, request);
    }

    async createForm(request) {
        return axiosPostAuthorize(CreateForm, request);
    }

    async updateForm(request, id) {
        return axiosPostAuthorize(UpdateForm, request, id);
    }

    async updateUser(request, id) {
        return axiosPostAuthorize(UpdateUser, request, id);
    }

    async deleteUser(request, id) {
        return axiosGetAuthorize(DeleteUser, request, id);
    }

    // Jobs
    async getJobList(request) {
        return axiosGetMultiParams(GetJobList, request);
    }

    async getFormsList(request) {
        return axiosGetMultiParams(GetFormList, request);
    }

    async getAllForms(request) {
        return axiosGetMultiParamsForWebToken(GetAllForms, request);
    }

    async deleteForm(request, id) {
        return axiosGetAuthorize(DeleteForm, request, id);
    }

    async getJobData(request) {
        return axiosGetAuthorizeByWebToken(GetJobData, request);
    }

    async getFormData(request) {
        return axiosGetAuthorizeByWebToken(GetFormData, request);
    }

    async createJob(request) {
        return axiosPostAuthorize(CreateJob, request);
    }

    async updateJob(request, id) {
        return axiosPostAuthorize(UpdateJob, request, id);
    }

    async deleteJob(request, id) {
        return axiosGetAuthorize(DeleteJob, request, id);
    }

    // Blog & News
    async getNewsBlogList(request) {
        return axiosGetMultiParamsForWebToken(GetNewsBlogList, request);
    }

    async getNewsBlogsData(request) {
        return axiosGetAuthorizeByWebToken(GetNewsBlogsData, request);
    }

    async createNewsBlogs(request) {
        return axiosPostAuthorize(CreateNewsBlogs, request);
    }

    async updateNewsBlogs(request, id) {
        return axiosPostAuthorize(UpdateNewsBlogs, request, id);
    }

    async deleteNewsBlogs(request, id) {
        return axiosGetAuthorize(DeleteNewsBlogs, request, id);
    }

    // Location
    async getLocationList(request) {
        return axiosGetMultiParamsForWebToken(GetLocationList, request);
    }

    async getLocationData(request) {
        return axiosGetAuthorizeByWebToken(GetLocationData, request);
    }

    async createLocation(request) {
        return axiosPostAuthorize(CreateLocation, request);
    }

    async updateLocation(request, id) {
        return axiosPostAuthorize(UpdateLocation, request, id);
    }

    async deleteLocation(request, id) {
        return axiosGetAuthorize(DeleteLocation, request, id);
    }

    // Policy
    async getPolicyList(request) {
        return axiosGetMultiParamsForWebToken(GetPolicyList, request);
    }

    async updatePolicyWebVisibility(request) {
        return axiosPostAuthorize(UpdatePolicyWebVisibility, request);
    }
    // async getLocationData(request) {
    //     return axiosGetAuthorizeByWebToken(GetLocationData, request);
    // }

    async createPolicy(request) {
        return axiosPostAuthorize(CreatePolicy, request);
    }

    async updatePolicy(request, id) {
        return axiosPostAuthorize(UpdatePolicy, request, id);
    }

    async deletePolicy(request, id) {
        return axiosGetAuthorize(DeletePolicy, request, id);
    }

    // Reports
    async getSubscriberList(request) {
        return axiosGetMultiParams(GetSubscriberList, request);
    }

    async getCVList(request) {
        return axiosGetMultiParams(GetCVList, request);
    }

    async userLogs(request) {
        return axiosGetMultiParams(UserLogs, request);
    }

    async timesheetDetails(request) {
        return axiosGetMultiParams(TimesheetDetails, request);
    }

    async submittedForms(request) {
        return axiosGetMultiParams(SubmittedForms, request);
    }

    async safeguardingForm(request) {
        return axiosGetMultiParams(SafeguardingForm, request);
    }

    // Dashboard
    async getDashboardData(request) {
        return axiosGetMultiParams(GetDashboardData, request);
    }

    async verifyAuth(token) {
        return axiosAuthParms(VerifyAuth, token);
    }

    async getContactUsList(request) {
        return axiosGetMultiParams(GetContactUsList, request);
    }

    // Forms
    async approveForm(request, id) {
        return axiosPostAuthorizeByWebToken(ApproveForm, request, id);
    }

    async getSubmittedFormDetailedData(submissionDataArray) {
        return axiosPostAuthorize(GetSubmittedFormDetailedData, submissionDataArray);
    }

    async downloadMergedForms(submissionDataArray) {
        return axiosPostAuthorizeBlob(DownloadMergedForms, { submissions: submissionDataArray });
    }

    // Score/Assessment Forms
    async createScoreForm(request) {
        return axiosPostAuthorize(CreateScoreForm, request);
    }

    async updateScoreForm(request, id) {
        return axiosPostAuthorize(UpdateScoreForm, request, id);
    }

    async getScoreFormData(request) {
        return axiosGetAuthorizeByWebToken(GetScoreFormData, request);
    }

    async deleteScoreForm(request, id) {
        return axiosGetAuthorize(DeleteScoreForm, request, id);
    }

    // Form Document Upload
    async uploadFormDocument(formData) {
        return axiosPostAuthorize(UploadFormDocument, formData, null, true);
    }

    // Configuration - CPD Images
    async uploadTempImage(formData) {
        return axiosPostAuthorize(UploadTempImage, formData, null, true);
    }

    async saveCPDImages(request) {
        return axiosPostAuthorize(SaveCPDImages, request);
    }

    async getCPDImages() {
        return axiosGetMultiParams(GetCPDImages, []);
    }

    async deleteCPDImage(request) {
        return axiosPostAuthorize(DeleteCPDImage, request);
    }

    async updateCPDImage(formData) {
        return axiosPostAuthorize(UpdateCPDImage, formData, null, true);
    }

    async updateImageOrder(request) {
        return axiosPostAuthorize(UpdateImageOrder, request);
    }

    // Handbooks
    async uploadHandbook(formData) {
        return axiosPostAuthorize(UploadHandbook, formData, null, true);
    }

    async getHandbook(type) {
        return axiosGetMultiParams(GetHandbook, [type]);
    }

    async deleteHandbook(request) {
        return axiosPostAuthorize(DeleteHandbook, request);
    }

    // EOM (Employee of the Month)
    async getEOMNominations(request) {
        return axiosGetMultiParams(GetEOMNominations, request);
    }

    async getEOMStatus() {
        return axiosGetMultiParams(GetEOMStatus, []);
    }

    async updateEOMStatus(request) {
        return axiosPostAuthorize(UpdateEOMStatus, request);
    }

    async deleteEOMNomination(id) {
        return axiosPostAuthorize(DeleteEOMNomination.replace('{0}', id), {});
    }

    async getEOMAvailableMonths() {
        return axiosGetMultiParams(GetEOMAvailableMonths, []);
    }

    // EOM Winners
    async saveEOMWinner(request) {
        return axiosPostAuthorize(SaveEOMWinner, request);
    }

    async getEOMWinner(month) {
        return axiosGetMultiParams(GetEOMWinner, [month]);
    }

    async getEOMWinners(month) {
        return axiosGetMultiParams(GetEOMWinners, [month]);
    }

    async deleteEOMWinner(id) {
        return axiosPostAuthorize(DeleteEOMWinner.replace('{0}', id), {});
    }

    async getEOMWinnerAvailableMonths() {
        return axiosGetMultiParams(GetEOMWinnerAvailableMonths, []);
    }

    // House Master
    async getHouseList(request) {
        return axiosGetMultiParams(GetHouseList, request);
    }

    async getHouseData(id) {
        return axiosGetAuthorize(GetHouseData, id);
    }

    async createHouse(request) {
        return axiosPostAuthorize(CreateHouse, request);
    }

    async updateHouse(request, id) {
        return axiosPostAuthorize(UpdateHouse, request, id);
    }

    async deleteHouse(id) {
        return axiosGetAuthorize(DeleteHouse, id);
    }

    // Visitor Logbook Reports
    async getVisitorReports(request) {
        return axiosGetMultiParams(GetVisitorReports, request);
    }
}